// extracted by mini-css-extract-plugin
export default {"root":"Footer_root__TpuKv","footer":"Footer_footer__Y5e7l","footer__margin":"Footer_footer__margin__flkE9","footer__Item":"Footer_footer__Item__uy+Hs"};